import { render, staticRenderFns } from "./lafiaTravelerSale.vue?vue&type=template&id=f08ca4d6"
import script from "./lafiaTravelerSale.vue?vue&type=script&lang=js"
export * from "./lafiaTravelerSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports